<template>
  <div
    v-bind:class="{
      'sch-msg-cell': historyItem.scheduledAt
    }"
    @click="editMessage(historyItem)"
    v-on:mouseover="
      $set(hoverCheck, 'scheduled-message-' + historyItem.id, true)
    "
    v-on:mouseleave="
      $set(hoverCheck, 'scheduled-message-' + historyItem.id, false)
    "
  >
    <v-row v-if="historyItem.scheduledAt" class="sch-msg-label">
      <v-col class="col-auto">
        <v-icon small>mdi-clock-outline</v-icon>&nbsp;Scheduled Message
      </v-col>
      <v-spacer></v-spacer>
      <v-col class="col text-right mr-4">
        <v-icon small>{{
          hoverCheck["scheduled-message-" + historyItem.id] ? "mdi-pencil" : ""
        }}</v-icon>
      </v-col>
    </v-row>
    <div
      v-bind:class="{
        'from-msg-bubble': historyItem.isInbound == true,
        'to-msg-bubble': historyItem.isInbound == false,
        'ml-auto': historyItem.isInbound == false
      }"
      class="msg-detail-bubble"
    >
      <div class="msg-bubble-content">
        <v-sheet
          class="no-whitespace msg-bubble-img"
          v-if="mediaToShow(historyItem) && mediaUrl"
          ><v-img
            class="msg-bubble-img"
            :src="mediaUrl"
            @click.prevent="openMediaInNewTab(mediaUrl)"
          ></v-img
        ></v-sheet>
        <div class="no-whitespace">{{ messageToShow(historyItem) }}</div>
      </div>
    </div>
    <div
      class="msg-detail-header"
      v-bind:class="{
        'ml-auto': historyItem.isInbound != true,
        'setting-msg-detail-header': !historyItem.id
      }"
    >
      <span v-if="historyItem.isInbound != true" class="msg-detail-name">{{
        userNameFromHistoryItem(historyItem)
          ? userNameFromHistoryItem(historyItem)
          : "Sombody"
      }}</span>
      <span v-else class="msg-detail-name">{{ customerName }}</span>
      <span class="msg-detail-time">{{
        historyItem.scheduledAt
          ? formattedDateTime(historyItem.scheduledAt)
          : formattedDateTime(historyItem.createdAt)
      }}</span>
      <div class="msg-detail-contact-info" v-if="historyItem.contactInfo">
        <i
          v-if="historyItem.contactInfo.label == 'mobile'"
          class="ui-icon mobile"
        ></i>
        <i
          v-else-if="historyItem.contactInfo.label == 'home'"
          class="ui-icon home"
        ></i>
        <i
          v-else-if="historyItem.contactInfo.label == 'work'"
          class="ui-icon office"
        ></i>
        <i
          v-else-if="historyItem.contactInfo.type == 'email'"
          class="ui-icon email"
        ></i>
        <i v-else class="ui-icon phone"></i>
        {{ historyItem.contactInfo.detail }}
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
import { API_BASE_URL } from "../../../globalVars";
import axios from "axios";

export default {
  name: "MessageContentBubble",
  components: {},
  props: {
    historyItem: Object,
    customerName: String
  },
  data: function() {
    return {
      hoverCheck: {},
      mediaUrl: null
    };
  },
  computed: {
    account() {
      return this.$store.getters["entities/accounts/query"]()
        .withAllRecursive(1)
        .first();
    }
  },
  created() {},
  watch: {},
  methods: {
    userNameFromHistoryItem(historyItem) {
      return historyItem.user ? historyItem.user.longName : "";
    },
    formattedDateTime(number) {
      return format(new Date(number), "E h:mm a, M/d/y");
    },
    messageToShow(item) {
      let showText = "";
      if (item.messageBody) {
        showText = item.messageBody.trim();
      }
      return showText;
    },
    mediaToShow(item) {
      if (item.media && item.media.urls && item.media.urls[0]) {
        this.updateMediaUrl(item.media.urls[0]);
        return true;
      }
      return false;
    },
    updateMediaUrl(path) {
      if (!path) return;
      let vueThis = this;
      const externalId = this.account.externalId;
      axios({
        method: "get",
        url:
          API_BASE_URL +
          `/account?do=file-url&externalId=${externalId}&path=account/${externalId}/message/${path}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`
        }
      }).then(response => {
        vueThis.mediaUrl = response && response.data ? response.data.url : null;
        console.log("url: " + vueThis.mediaUrl);
      });
    },
    openMediaInNewTab(url) {
      window.open(url, "_blank");
    },
    editMessage(historyItem) {
      if (historyItem.type == "msgSch") {
        this.$parent.$parent.newMessageText = historyItem.messageBody;
        this.$parent.$parent.messageScheduledIdToEdit = historyItem.id;
        this.$parent.$parent.messageScheduledDateToEdit =
          historyItem.scheduledAt;
        this.$parent.$parent.newMessage = true;
      }
    }
  }
};
</script>

<style scoped lang="stylus">
.msg-bubble-img {
  max-height: 200px;
  max-width: 200px;
}
.sch-msg-label {
  font-weight: 500;
  width: 80%;
  margin-left: auto;
}
.sch-msg-cell:hover {
  cursor: pointer;
  background-color: #efefef;
}
.setting-msg-detail-header {
  width: unset;
}
</style>
